import formsBackendClient, { type ApiDefinition } from '@/tsClient/servers/noodleQuestionnaires';

import buildPath from '../utilities/buildPath';

type ThisApi = ApiDefinition['/questionnaires/{questionnaireId}/validate']['POST'];

/** Calls the filing-gate validation endpoint and returns the structured result. */
const validateQuestionnaire = async (questionnaireId: string): Promise<ThisApi['response']> => {
  const path = buildPath<ThisApi>('/questionnaires/{questionnaireId}/validate', { questionnaireId });
  const response = await formsBackendClient.post(path);
  return response.data;
};

export default validateQuestionnaire;
